import { Visibility } from '@mui/icons-material';
import React from 'react'

export const DetailsComponents = () => {
  return (
    <>
        <div
            style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 12,
            padding: '0px 16px',
            backgroundColor: '#F9F9F9',
            borderRadius: 8,
            }}
        >
            <div
            style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '6px 12px',
                borderRadius: 6,
                transition: 'background-color 0.3s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#E0F2F1')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
            <Visibility sx={{ color: '#33ABA0', fontSize: 20 }} />
            <span
                style={{
                color: '#333',
                fontWeight: 600,
                marginInlineStart: 6,
                fontSize: 14,
                }}
            >
                Detalle
            </span>
            </div>
        </div>
    </>
  )
}
